/** A single description for roles on the company level. */

/**
 * Object that determines all different permission rules for users to get
 * access on the company level.
 */

/**
 * Signature for the function hasUserValidRoleCompanyLevel.
 */

/** Names for all permissions or roles within the company level. */
export let RequiredRoleCompanyLevelName = /*#__PURE__*/function (RequiredRoleCompanyLevelName) {
  /** Whether the user has permission to access the member profile page */
  RequiredRoleCompanyLevelName["canViewCompanyMemberProfile"] = "canViewCompanyMemberProfile";
  /** Whether the user has permission to change the display name */
  RequiredRoleCompanyLevelName["canChangeDisplayName"] = "canChangeDisplayName";
  /** Whether the user has permission to add members to the company */
  RequiredRoleCompanyLevelName["canInviteUsersToCompany"] = "canInviteUsersToCompany";
  /** Whether the user has permission to resend invitations */
  RequiredRoleCompanyLevelName["canResendInvitationToCompany"] = "canResendInvitationToCompany";
  /** Whether the user has permission to edit member */
  RequiredRoleCompanyLevelName["canEditMember"] = "canEditMember";
  /** Whether the user can delete a member from a company or not */
  RequiredRoleCompanyLevelName["canDeleteMemberFromCompany"] = "canDeleteMemberFromCompany";
  /** Whether the user has permission to create groups */
  RequiredRoleCompanyLevelName["canCreateGroups"] = "canCreateGroups";
  /** Whether the user has permission to edit the company default platform to open projects */
  RequiredRoleCompanyLevelName["canEditDefaultPlatform"] = "canEditDefaultPlatform";
  /** Whether the user has permission to create new team */
  RequiredRoleCompanyLevelName["canCreateNewTeam"] = "canCreateNewTeam";
  /** Whether the user has permission to remove members from the team */
  RequiredRoleCompanyLevelName["canDeleteMembersFromTeam"] = "canDeleteMembersFromTeam";
  /** Whether the user has permission to view teams */
  RequiredRoleCompanyLevelName["canViewTeams"] = "canViewTeams";
  /**
   * Whether the user has permission to fetch teams from the backend.
   * Currently all users can fetch teams, but this permission is added for future use.
   */
  RequiredRoleCompanyLevelName["canFetchTeams"] = "canFetchTeams";
  /** Whether the user has permission to edit a team */
  RequiredRoleCompanyLevelName["canEditTeams"] = "canEditTeams";
  /** Whether the user has permission to delete a team */
  RequiredRoleCompanyLevelName["canDeleteTeams"] = "canDeleteTeams";
  /** Whether the user has permission to add members to the team */
  RequiredRoleCompanyLevelName["canInviteMembersToTeam"] = "canInviteMembersToTeam";
  /** Whether the user has permission to remove a member or team from a project */
  RequiredRoleCompanyLevelName["canRemoveMemberFromProject"] = "canRemoveMemberFromProject";
  /** Whether the user has permission to change a member's role in a project from the member/team profile page */
  RequiredRoleCompanyLevelName["canChangeMemberProjectRole"] = "canChangeMemberProjectRole";
  /** Whether the user has permission to view the subscription details */
  RequiredRoleCompanyLevelName["canViewSubscriptionDetails"] = "canViewSubscriptionDetails";
  /** Whether the user has permission to view the product details */
  RequiredRoleCompanyLevelName["canViewProductDetails"] = "canViewProductDetails";
  /** Whether the user has permission to export the workspace data */
  RequiredRoleCompanyLevelName["canExportWorkspace"] = "canExportWorkspace";
  /** Whether the user has permission to edit all company projects */
  RequiredRoleCompanyLevelName["canEditAllCompanyProjects"] = "canEditAllCompanyProjects";
  /** Whether the user has permission to give SCENE licenses to members or to take them away */
  RequiredRoleCompanyLevelName["canManageSceneLicenses"] = "canManageSceneLicenses";
  /** Whether the user has permission to give Sphere XG seats to members */
  RequiredRoleCompanyLevelName["canManageXgSeats"] = "canManageXgSeats";
  return RequiredRoleCompanyLevelName;
}({});